"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAddress = exports.LeafLetDivIcon = exports.combineCustomViewBox = exports.makePolygonUnion = exports.convertToPoints = exports.getBoundsByCompassDirections = exports.applyPolygonToMap = exports.isPolygonClockWise = void 0;
var GoogleGeocoding_1 = __importDefault(require("../constants/GoogleGeocoding"));
var polygon_clipping_1 = __importDefault(require("polygon-clipping"));
var simplify_js_1 = __importDefault(require("simplify-js"));
var leaflet_1 = __importDefault(require("leaflet"));
/**
 * Checks if polygon is clockwise or not, it is helpful fo creating
 * double layers svgs and checking intersections of two polygons
 * @param coords
 * @returns { boolean }
 */
var isPolygonClockWise = function (coords) {
    var sum = 0;
    for (var i = 0; i < coords.length; i++) {
        var next = i === coords.length - 1 ? 0 : i + 1;
        var current = i;
        sum +=
            (coords[next].x - coords[current].x) *
                (coords[next].y + coords[current].y);
    }
    return sum > 0;
};
exports.isPolygonClockWise = isPolygonClockWise;
var applyPolygonToMap = function (polygons, map, reverseCoords) {
    if (reverseCoords === void 0) { reverseCoords = false; }
    var worldCoords = GoogleGeocoding_1.default.WORLD_COORDINATES.map(function (points) { return new google.maps.LatLng(points[0], points[1]); });
    var polysCoords = [];
    polygons.map(function (p) {
        p.map(function (coords) {
            var latLng = coords.map(function (point) {
                if (reverseCoords) {
                    return new google.maps.LatLng(Number(point[1]), Number(point[0]));
                }
                else {
                    return new google.maps.LatLng(Number(point[0]), Number(point[1]));
                }
            });
            polysCoords.push(latLng);
        });
    });
    var gPolygon = new google.maps.Polygon(__assign(__assign({}, GoogleGeocoding_1.default.POLYGON_STYLES), { paths: __spreadArray([worldCoords], polysCoords) }));
    gPolygon.setMap(map);
    return gPolygon;
};
exports.applyPolygonToMap = applyPolygonToMap;
var getBoundsByCompassDirections = function (geometry) {
    var sw = new google.maps.LatLng(geometry['south'], geometry['west']);
    var ne = new google.maps.LatLng(geometry['north'], geometry['east']);
    return { sw: sw, ne: ne };
};
exports.getBoundsByCompassDirections = getBoundsByCompassDirections;
var convertToPoints = function (points) {
    return points.map(function (item) {
        var arr = simplify_js_1.default(__spreadArray([], item), 2, true);
        // Need to reverse coordinates for creating svg fill boundaries
        if (exports.isPolygonClockWise(arr)) {
            arr = arr.reverse();
        }
        return arr;
    });
};
exports.convertToPoints = convertToPoints;
var makePolygonUnion = function (coords) {
    return polygon_clipping_1.default.union(coords.map(function (item) {
        var a = [];
        a.push(item.map(function (_a) {
            var x = _a.x, y = _a.y;
            return [x, y];
        }));
        return a;
    }));
};
exports.makePolygonUnion = makePolygonUnion;
var combineCustomViewBox = function (additionalQuery) {
    var _a;
    var customViewBox = [];
    customViewBox[0] = (_a = additionalQuery.customViewBox[0]) === null || _a === void 0 ? void 0 : _a.map(function (viewBox) {
        return viewBox.map(function (boxItem) {
            return boxItem.map(function (item) { return Number(item); });
        });
    });
    return customViewBox;
};
exports.combineCustomViewBox = combineCustomViewBox;
var LeafLetDivIcon = function () {
    var icons = {};
    return function (count, className) {
        if (!icons[count]) {
            icons[count] = leaflet_1.default.divIcon({
                className: className,
                html: "<div>" + ceilIconCount(count) + "</div>",
            });
        }
        return icons[count];
    };
};
exports.LeafLetDivIcon = LeafLetDivIcon;
var ceilIconCount = function (count) {
    if (count > 2 && count < 10) {
        return '2+';
    }
    if (count > 10 && count < 100) {
        return '10+';
    }
    if (count > 100) {
        return '100+';
    }
    if (count > 1000) {
        return '1000+';
    }
    return count;
};
var formatAddress = function (address) {
    // Makes address value shorter, without additional details.
    var formattedAddress;
    var splitAddress = address.split(',');
    // checking if address starts with integer (for example number of building etc.)
    if (splitAddress.length > 1 && splitAddress[0].match(/^\d/)) {
        formattedAddress = splitAddress.slice(0, 2).join();
    }
    else {
        formattedAddress = splitAddress[0];
    }
    return formattedAddress;
};
exports.formatAddress = formatAddress;
